<div class="chat-window" role="dialog" aria-label="Rocket Assist"> <!-- NOSONAR -->
  <header class="chat-window__header">
    <div class="chat-window__brand">
      <span class="chat-window__icon-well">
        <img src="assets/icons/rocket-assist-chat.svg" width="32" height="32" aria-hidden="true" alt="">
      </span>
      <h2 class="chat-window__title">Rocket Assist</h2>
    </div>
    <div class="chat-window__header-actions">
      <button type="button" class="chat-window__icon-button" aria-label="Minimize" (click)="minimize.emit()">
        <mat-icon aria-hidden="true">remove</mat-icon>
      </button>
      <button type="button" class="chat-window__icon-button" aria-label="Close" (click)="closed.emit()">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
  </header>

  @if (rootChips.length && selectedRootChipId !== '') {
    <div class="chat-window__root-chips">
      @for (chip of rootChips; track chip.id) {
        <button
          type="button"
          class="chat-window__chip chat-window__chip--root"
          [class.chat-window__chip--active]="chip.id === selectedRootChipId"
          [disabled]="chipsDisabled"
          (click)="onChipClick(chip)"
        >{{ chip.label }}</button>
      }
    </div>
  }

  <div class="chat-window__body">
    <p class="chat-window__disclaimer">
      This AI-powered FAQ may process your interactions to improve quality and accuracy. Learn more in our
      <a class="chat-window__disclaimer-link" href="https://www.rocketclose.com/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.
    </p>

    @for (item of items; track $index) {
      @if (isBubble(item)) {
        <div class="chat-window__bubble-row" [class.chat-window__bubble-row--user]="item.kind === 'user'">
          <div class="chat-window__bubble"
               [class.chat-window__bubble--bot]="item.kind === 'bot'"
               [class.chat-window__bubble--user]="item.kind === 'user'">
            @switch (item.text) {
              @case ('who') {
                <div>
                  <p class="qa-answer">Everyone listed on the closing will need to sign the required documents.</p>
                  @if ((borrowers$ | async)?.length) {
                    <ul class="qa-answer">
                      @for (user of borrowers$ | async; track user.packageUserGuid) {
                        <li>{{ user.firstName }} {{ user.lastName }} ({{ roleLabel(user.userRoleCode) }})</li>
                      }
                    </ul>
                  }
                </div>
              }
              @case ('copies') {
                <p class="qa-answer">After the closing is complete, a signed copy of the documents will be available. You can also view and download them from your Rocket Account.</p>
              }
              @case ('proof') {
                <p class="qa-answer">Yes, you'll need to show a physical form of ID proof, either a driver's license or state-issued ID to the notary on camera.</p>
              }
              @case ('sessiontake') {
                <p class="qa-answer">Most closings take around 35 minutes, though some may be a little shorter or longer.</p>
              }
              @case ('nbthsign') {
                <p class="qa-answer">Even though NBTH signer is not on the loan, they need to sign the documents as they are part of the title.</p>
              }
              @case ('loaninfo') {
                <div class="qa-loan-info">
                  @if (disbursementDate$ | async; as date) {
                    <p class="qa-answer">Disbursement date: <strong>{{ date | date: 'MM/dd/yyyy' }}</strong></p>
                  }
                  @if (interestRate$ | async; as rate) {
                    <p class="qa-answer">Interest rate: <strong>{{ rate | percent: '1.2-4' }}</strong></p>
                  }
                  @if (monthlyPayment$ | async; as payment) {
                    <p class="qa-answer">Monthly payment: <strong>{{ payment | currency }}</strong></p>
                  }
                  @if (firstPaymentDate$ | async; as date) {
                    <p class="qa-answer">First payment date: <strong>{{ date | date: 'MM/dd/yyyy' }}</strong></p>
                  }
                  @if (prepaymentPenalty$ | async; as penalty) {
                    <p class="qa-answer">Prepayment penalty: <strong>{{ penalty }}</strong></p>
                  }
                </div>
              }
              @case ('payoffs') {
                <div>
                  @if (disbursementDate$ | async; as date) {
                    <p class="qa-answer">Payoffs are completed on your disbursement date: <strong>{{ date | date: 'MM/dd/yyyy' }}</strong>.</p>
                  }
                  <p class="qa-answer">Creditor payments are issued as cashier's checks payable to each creditor and sent via UPS (no signature required) on funds disbursement date with instructions included. Any remaining funds are sent directly by Rocket Close.</p>
                  @for (payoff of payoffs$ | async; track payoff.recipient) {
                    <p class="qa-answer"><strong>{{ payoff.recipient }}</strong> &ndash; {{ payoff.amount | currency }}</p>
                  }
                </div>
              }
              @case ('escrow') {
                <p class="qa-answer">If Rocket Mortgage is your lender, any escrow overage may be returned to you or applied to your loan principal.</p>
              }
              @case ('autopay') {
                <p class="qa-answer">Instructions will be available in your RKT Mortgage account after funds are disbursed.</p>
              }
              @case ('discrepancies') {
                <p class="qa-answer">We are sorry for the inconvenience. Please contact the Rocket Mortgage Closing Team: <a class="qa-answer__phone" href="tel:8888485309">888-848-5309</a></p>
              }
              @case ('proceeds') {
                <p class="qa-answer">Review the Loan Proceeds Delivery Instructions document and update if needed.</p>
              }
              @case ('incorrect') {
                <p class="qa-answer">We are sorry for the inconvenience. Please contact the Rocket Mortgage Closing Team: <a class="qa-answer__phone" href="tel:8888485309">888-848-5309</a></p>
              }
              @case ('morethaniowe') {
                <p class="qa-answer">Once the creditor receives payment, they are responsible to issue any overage to you. If Rocket Mortgage is the creditor, they will either refund the overage or apply it to your loan principal.</p>
              }
              @case ('fundsdueatclosing') {
                <p class="qa-answer">You will find info on this at the end of the closing.</p>
              }
              @default {
                {{ item.text }}
              }
            }
          </div>
        </div>

        @if (rootChips.length && selectedRootChipId === '') {
          <div class="chat-window__chips chat-window__chips--row">
            @for (chip of rootChips; track chip.id) {
              <button
                type="button"
                class="chat-window__chip chat-window__chip--root"
                [disabled]="chipsDisabled"
                (click)="onChipClick(chip)"
              >{{ chip.label }}</button>
            }
          </div>
        }
      }
      @if (isTyping(item)) {
        <div class="chat-window__bubble-row">
          <div class="chat-window__bubble chat-window__bubble--bot chat-window__typing" aria-label="Assistant is typing">
            <span class="chat-window__typing-dot"></span>
            <span class="chat-window__typing-dot"></span>
            <span class="chat-window__typing-dot"></span>
          </div>
        </div>
      }
    }

    @if (chips.length && selectedRootChipId !== '') {
      <div class="chat-window__chips" [class.chat-window__chips--column]="chipsDirection === 'column'">
        @for (chip of chips; track chip.id) {
          <button
            type="button"
            class="chat-window__chip"
            [disabled]="chipsDisabled"
            (click)="onChipClick(chip)"
          >{{ chip.label }}</button>
        }
      </div>
    }
  </div>
</div>
